module.exports = __webpack_public_path__ + "media/images/common/confirm_btn_l_ov-452371799f0a69db6fd1b67e6fba98d1.png";